import React,{useState,useEffect} from 'react'

import { Header,ElectionCard } from '../components'
// import { electionsCandidates } from '../sampleData'
import Swal from 'sweetalert2'
import axios from 'axios'
import axiosClient from '../axios-client'

const Election = () => {
  const [candidates,setCandidates] = useState([])
  const userId = localStorage.getItem('userId')


  useEffect(() => {
    // const url = 'http://localhost:5000/api/candidates'
    
    axios.get(`https://mykura-nodejs-backend-fca8901da273.herokuapp.com/api/candidates/${userId}`)
    .then((res) => {
      if (res.data.data) setCandidates(res.data.data)
      if (res.data.issue) {
        Swal.fire({
          icon:'warning',
          title:'Already voted!',
        })
      }
    })
    .catch((err) => console.log(err))
  },[userId])


  const handleSubmit = (e) => {
    e.preventDefault()

    const form = e.target.children[0]
    const containers = form.children
    const chosen = []

    for (let i = 0; i < containers.length; i++)
    {
        const fields = containers[i].children[1].children
        for (let j = 0; j < fields.length; j++)
        {
          const inputs = fields[j].children[1]
          if (inputs.checked) chosen.push(inputs.value)
        }
    }

    console.log(chosen)

    Swal.fire({
      icon:'warning',
      title:'Confirmation!',
      text:'Are you satisfied with your choice',
      showCancelButton:true,
      confirmButtonText:'Yes, am sure'
  
    })
    .then((result) => {
      if (result.isConfirmed){
        const payload = {identity:userId,candidates:chosen}
        const url = 'http://localhost:5000/api/vote'
        axios.post(url,payload)
        .then((res) => {
          console.log(res)
          Swal.fire({
            title:'Just voted',
            text:"You have successfully voted",
            icon:'success'
          })  
        })
      .catch((err) => console.log(err))
        
      }
      
    })
  }
  return (
    <div className='h-screen mx-1 flex flex-col items-center'>
      <Header pageView='Election'/>
      <form 
      onSubmit={handleSubmit}
      className='mt-5 grid gap-4 w-[300px]'>
        <div className='grid gap-4 w-[300px]'>
          {candidates.map((d,i) => {
            return (
              // <p>{d.title}</p>
              <ElectionCard
              key={i}
              candidates={d.candidates}
              position={d.title}
              />
            )
          })}
        </div>

        <button
        type='submit'
        className='bg-purple text-light py-1 cursor-pointer font-semibold'
        >
          Vote
        </button>
      </form>
      

    </div>
  )
}

export default Election